import { render, staticRenderFns } from "./ContractOverview.vue?vue&type=template&id=5c4f912a&"
import script from "./ContractOverview.vue?vue&type=script&lang=ts&"
export * from "./ContractOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports